module.exports = __webpack_public_path__ + "static/img/firstPageBanner.05beefbb.png";